export const extractError = (apiError) => {
    let errorMessage = apiError?.message;
    let errors = {};
    let httpStatus= 500;
    if (apiError.response) {
        if (apiError.response?.status){
            httpStatus = apiError.response.status;
        }

        if (apiError.response?.data?.messageKey){
            errorMessage = apiError.response.data.messageKey;

        }

        if (apiError.response?.data?.message){
            errorMessage = apiError.response.data.message;
        }

        if (apiError.response?.data?.errors){
            errors = apiError.response.data?.errors;
        }
    }
    return {message: errorMessage, errors: errors, httpStatus: httpStatus};
}


export const extractBlobError = async(apiError) => {
    let errorMessage = apiError?.message;
    let errors = {};
    let httpStatus= 500;
    if (apiError.response) {
        if (apiError.response.hasOwnProperty("status")){
            httpStatus = apiError.response.status;
        }

        if (!apiError.response.hasOwnProperty("data")){
            return {message: errorMessage, errors: {}, httpStatus: httpStatus};
        }

        let data = apiError.response.data;

        if (data instanceof Blob ){
            data = JSON.parse(await data.text());
        }

        if (data.hasOwnProperty("messageKey")){
            errorMessage = data.messageKey;
        }

        if (data.hasOwnProperty("message")){
            errorMessage = data.message;
        }

        if (data.hasOwnProperty("errors")){
            errors = data.errors;
        }
    }
    return {message: errorMessage, errors: errors, httpStatus: httpStatus};
}